import React from 'react'
import DetailContainer from '../MainPage/common/DetailContainer'
import { images } from '../common/images';

function PowerDetailContainer({ phaseLoadLogs, phaseWiseData, phase, deviceId }) {

    // Find the last valid log that doesn't have the 'ct' key which means that log will be of 'disconnect' type
    const validPhaseData = phaseWiseData.filter(log => !log.hasOwnProperty('ct')).sort((a, b) => a.ts - b.ts);
  
    // Check if there is a valid log to display
    const lastValidLog = validPhaseData.length > 0 ? validPhaseData[validPhaseData.length - 1] : null;

  return (
    <DetailContainer
      name={`Power ${Object.keys(phaseLoadLogs[deviceId]).length > 1 ? Number(phase) + 1 : ''}`}
      value={`${(Object.keys(phaseLoadLogs)?.length === 1 &&
        lastValidLog
        ? lastValidLog.p
        : 0
      ).toFixed(2)} W`}
      time={
        Object.keys(phaseLoadLogs)?.length !== 0 &&
          lastValidLog!==null
          ? lastValidLog.ts
          : new Date().getTime()
      }
      color={"#FDECEC"}
      borderColor={"#EF4444"}
      image={images.powerFactor}
    />
  )
}

export default PowerDetailContainer